import { httpsCallable } from "@firebase/functions";
import { functions } from "../../firebase/FirebaseProvider";

/**
 * Add a country to a user's countriesVisited array
 * @param countryCode - ISO 3166-1 alpha-2 country code (e.g., "GB", "US", "FR")
 * @param targetUserId - Optional user ID to update. If not provided, updates the authenticated user
 * @returns Promise with result status
 */
export async function addCountryVisited(countryCode: string, targetUserId?: string): Promise<{ status: number; code: string }> {
    const addCountryVisitedFn = httpsCallable(functions, 'addCountryVisited');
    
    try {
        const result = await addCountryVisitedFn({ countryCode, targetUserId });
        return result.data as { status: number; code: string };
    } catch (error) {
        console.error("Error adding country visited:", error);
        throw error;
    }
}
